export default {
	title: '战略计划',
	tabs: {
		general: {
			title: '常规'
		},
		filters: {
			title: '视图筛选'
		},
		bot: {
			title: '智能'
		},
		export: {
			title: '导出'
		},
		display: {
			title: '显示'
		}
	},
	filters: {
		responsible: {
			title: '按负责人筛选',
			placeholder: '负责人姓名'
		},
		completion: {
			title: '完成度筛选',
			not_started: '未开始',
			in_progress: '进行中',
			completed: '已完成'
		},
		dates: {
			title: '日期筛选'
		},
		startOn: {
			title: '开始日期筛选',
			undefined: '无日期',
			past: '已过',
			ending_week: '一周内开始',
			ending_month: '一月内开始',
			ending_quarter: '一季度内开始',
			ending_year: '一年内开始'
		},
		endOn: {
			title: '结束日期筛选',
			undefined: '无日期',
			done: '已完成',
			overdue: '已逾期',
			ending_week: '一周内结束',
			ending_month: '一月内结束',
			ending_quarter: '一季度内结束',
			ending_year: '一年内结束'
		}
	},

	display: {
		sort: {
			title: '分支排序',
			startOn: '按开始日期',
			name: '按名称',
			manual: '手动排序'
		}
	},
	all_icons: '图标筛选',
	no_icon: '无图标',
	onboarding: {
		title: '行动计划评审',
		description:
			'确认轴与项目与您对计划的理解一致。'
	}
};
